<template>
    <div class="wrapper">

        <header v-if="!isPhone">
            <TheHeaderBar :title="'订单详情'"/>
        </header>

        <div class="content">

            <!--收货地址信息-->
            <div class="address-box">
                <div class="icon" style="flex:10%;">
                    <van-icon name="location" size="30"/>
                </div>
                <div class="address-info-box" style="flex:90%;">
                    <div class="address-base-info-box">
                        <span class="address-name">{{orderDetailsInfo.address_name}}</span>
                        <span class="address-tel">{{orderDetailsInfo.address_tel}}</span>
                    </div>
                    <div class="address-base-text">
                        {{orderDetailsInfo.address_province}}
                        {{orderDetailsInfo.address_city}}
                        {{orderDetailsInfo.address_district}}
                        {{orderDetailsInfo.address_detail}}
                    </div>
                </div>
            </div>

            <!--物流信息-->
            <div class="logistics-box">
                <div class="title">物流信息</div>
                <div class="logistic-info">
                    <div>{{logisticInfo.express_company}}</div>
                    <div v-if="logisticInfo.express_no">
                        <span>快递单号：{{logisticInfo.express_no}}</span>
<!--                        <span style="margin-left: 5px;">(复制)</span>-->
                    </div>
                </div>
                <van-steps direction="vertical" :active="0" v-if="logisticInfo.traces.length > 0">
                    <van-step v-for="item in logisticInfo.traces">
                        <p>{{item.AcceptStation}}</p>
                        <p>{{item.AcceptTime}}</p>
                    </van-step>
                </van-steps>
                <div v-else style="padding: 0 10px;box-sizing: border-box">
                    正在等待发货
                </div>
            </div>

            <!--商品信息-->
            <div class="goods-content">
                <div class="goods-box">
                    <div class="goods-img">
                        <img :src="orderDetailsInfo.goods_logo" alt="">
                    </div>
                    <div class="goods-info">
                        <div class="goods-name">{{orderDetailsInfo.goods_name}}</div>
                        <div class="goods-size">{{orderDetailsInfo.goods_spec}}</div>
                    </div>
                    <div class="goods-num">
                        <div class="price">￥{{orderDetailsInfo.goods_price}}</div>
                        <div style="display: flex;align-items: center;justify-content: center">
                            <van-icon name="cross" />
                            {{orderDetailsInfo.num}}
                        </div>
                    </div>
                </div>

                <div class="item price">
                    <van-cell title="订单总价" :value="(parseFloat(orderDetailsInfo.goods_price) * orderDetailsInfo.num  + parseFloat(orderDetailsInfo.freight)).toFixed(2)" />
                </div>
                <div class="item price">
                    <van-cell title="商品总价" :value="(parseFloat(orderDetailsInfo.goods_price) * orderDetailsInfo.num).toFixed(2)" />
                </div>
                <div class="item price">
                    <van-cell title="邮费" :value="parseFloat(orderDetailsInfo.freight) === 0 ? '包邮' : orderDetailsInfo.freight" />
                </div>
                <div class="item price">
                    <van-cell title="使用红包数量" :value="orderDetailsInfo.use_hb" />
                </div>

            </div>

            <!--订单信息-->
            <div class="order-content">
                <div class="order-title">订单信息</div>
                <div class="order-info">
                    <div class="item">
                        <van-cell title="订单编号" :value="orderDetailsInfo.order_no" />
                    </div>
                    <div class="item">
                        <van-cell title="创建时间" :value="orderDetailsInfo.created_at" />
                    </div>
                    <div class="item">
                        <van-cell title="备注" :value="orderDetailsInfo.remarks" />
                    </div>
                </div>
            </div>

        </div>

        <footer class="footer">
            <van-button round type="danger" v-if="orderDetailsInfo.status === 1" size="large" @click="handleReceivingGoods">确认收货</van-button>
        </footer>
    </div>
</template>

<script>
    import TheHeaderBar from "../../components/base/TheHeaderBar";
    import {getLogisticsService, getOrderDetailsService,receivingGoodsService} from "../../service/userService";
    import {Toast,Dialog} from 'vant';
    import {getUrlParamsTools, phoneInteractiveTools} from "../../util/tools";
    import phoneInteractiveData from "../../data/phoneInteractiveData";
	import {wecharShare} from "../../util/weChat.js";
    export default {
        name: "OrderDetails",
        data(){
            return{
                orderId:null,
                orderDetailsInfo:{},
                logisticInfo:{//物流信息
                    traces:[]
                },
                isPhone: false,
                phoneState:"IOS",
            }
        },
        mounted() {
            const state = getUrlParamsTools('isPhone') ;
            if(state){
                this.isPhone = true;
                phoneInteractiveTools(phoneInteractiveData.interactiveTitle,this.phoneState,'订单详情');
            }
            this.orderId = this.$route.params.orderId;
            this.getOrderDetails();
            this.getLogistics();
			//wecharShare(location.href.split('#')[0],location.href.split('#')[1]);
        },
        methods:{

            //获取订单详细信息
            getOrderDetails(){
                getOrderDetailsService(this.orderId).then(res => {
                    if(res.status === 1){
                        this.orderDetailsInfo = res.datas;
                        console.log( this.orderDetailsInfo)
                    }else{
                        Toast(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                }).finally(() => {});
            },

            //获取我的收货地址信息
            getLogistics(){
                getLogisticsService(this.orderId).then(res => {
                    if(res.status === 1){
                        this.logisticInfo = res.datas;
                        this.logisticInfo.traces.reverse();
                    }else{
                        Toast(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                })
            },

            //确认订单信息
            handleReceivingGoods(){
                receivingGoodsService(this.orderDetailsInfo.id).then(res => {
                    if(res.status === 1){
                        Dialog.alert({
                            title : '提示',
                            message:'收货成功',
                        }).then(() => {
                            this.$router.go(-1);
                        })
                    }else {
                        Toast(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                }).finally(() => {})
            },

        },
        components: {
            TheHeaderBar,
        }
    }
</script>

<style scoped lang="scss">
    .wrapper{
        header{
            padding-bottom: 46px;
        }
        .content{
            .address-box{
                display: flex;
                align-items: center;
                justify-content: space-between;
                background: #ffffff;
                padding: 5px;
                box-sizing: border-box;
                margin: 10px 0;
            }
            .logistics-box{
                margin-top: 10px;
                background: #ffffff;
                padding: 10px;
                box-sizing: border-box;
                .title{
                    box-sizing: border-box;
                }
                .logistic-info{
                    padding: 10px;
                    box-sizing: border-box;
                    div{
                        &:nth-child(1){
                            font-size: 14px;
                            color: #000000;
                            margin-bottom: 5px;
                        }
                    }
                }

            }
            .goods-content{
                .goods-box{
                    margin-top: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background-color: #ffffff;
                    padding: 10px;
                    box-sizing: border-box;
                    .goods-img{
                        flex: 10%;
                        img{
                            width: 100px;
                            height: 100px;
                            border-radius: 5px;
                        }
                    }
                    .goods-info{
                        flex: 80%;
                        padding: 0 5px;
                        box-sizing: border-box;
                        div{
                            padding: 5px 0;
                        }
                        .goods-name{
                            font-size: 14px;
                            color: #000000;
                        }
                    }
                    .goods-num{
                        flex: 10%;
                        text-align: center;
                    }
                }

            }
            .order-content{
                background-color: #ffffff;
                margin-top: 10px;
                padding: 10px;
                box-sizing: border-box;
                .order-title{
                    font-size: 14px;
                    color: #000000;
                }
            }

        }
        .footer{
            padding: 10px;
            box-sizing: border-box;
        }
    }
</style>